import {
    request
} from "../../main.top";

function setCookiesEvents(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + encodeURIComponent(value) + ";" + expires + ";path=/";
}

function normalizeEventUrl(url) {
    if (!url) return url;
    try {
        const parsed = new URL(url, window.location.origin);
        // Homolog/staging host → produção
        if (
            parsed.hostname === "site-mzgroup.com.br" ||
            parsed.hostname === "mzgroupcombr.wpcomstaging.com" ||
            parsed.hostname === "portal.mzgroup.com"
        ) {
            parsed.hostname = "www.mzgroup.com.br";
            parsed.protocol = "https:";
        }
        // Legado: /eventos/ (conflito com attachment) → /evento/
        if (parsed.pathname.startsWith("/eventos/")) {
            parsed.pathname = parsed.pathname.replace(/^\/eventos\//, "/evento/");
        }
        // Nunca usar a LP genérica
        if (parsed.pathname.replace(/\/$/, "") === "/eventolp") {
            return "";
        }
        return parsed.toString();
    } catch (e) {
        return url;
    }
}

function saveNewWebcastLog(reqBody) {
    let targetUrl = normalizeEventUrl(reqBody.webcastLink);
    reqBody.webcastLink = targetUrl;

    request("POST", ajaxurl, reqBody, function (req) {
        const result = JSON.parse(req);

        if (result.success === true) {
            const expireTime = new Date(new Date().setMinutes(new Date().getMinutes() + 30)).toUTCString();
            document.cookie = "name=" + reqBody.name + ";path=/;expires=" + expireTime;
            document.cookie = "email=" + reqBody.email + ";path=/;expires=" + expireTime;
            document.cookie = "companyName=" + reqBody.company + ";path=/;expires=" + expireTime;
            document.cookie = "phone=" + reqBody.phone + ";path=/;expires=" + expireTime;

            window.localStorage.setItem("userInfoCookies", JSON.stringify({
                name: reqBody.name,
                email: reqBody.email,
                company: reqBody.company,
                phone: reqBody.phone,
            }));

            setCookiesEvents("cadastroForm", "1", 30);

            if (targetUrl) {
                if (targetUrl.includes("calendar.google")) {
                    window.open(targetUrl, "_blank");
                } else {
                    window.location.assign(targetUrl);
                }
            }
        }
    });
}

export function openResearchPopup(webcastName, webcastLink, _unusedPopup, postId, type) {
    const webcastAccessPopup = document.getElementById("signInPopup");
    if (!webcastAccessPopup) return;

    const researchForm = webcastAccessPopup.querySelector(".card > form.signInEvent");
    if (!researchForm) return;

    const popupName = webcastAccessPopup.querySelector('input[name="name"]');
    const popupEmail = webcastAccessPopup.querySelector('input[name="email"]');
    const popupCompany = webcastAccessPopup.querySelector('input[name="company"]');
    const popupPhone = webcastAccessPopup.querySelector('input[name="phone"]');
    const popupWebcastName = webcastAccessPopup.querySelector('input[name="webCastName"]');
    const popupWebcastLink = webcastAccessPopup.querySelector('input[name="webCastLink"]');

    const normalizedLink = normalizeEventUrl(webcastLink);

    // .value (não só setAttribute) — senão o submit pode ler URL antiga
    if (popupWebcastName) popupWebcastName.value = webcastName || "";
    if (popupWebcastLink) popupWebcastLink.value = normalizedLink || "";
    researchForm.dataset.eventUrl = normalizedLink || "";
    researchForm.dataset.postId = postId != null ? String(postId) : "";
    researchForm.dataset.eventType = type || "";

    if (!researchForm.dataset.mzSubmitBound) {
        researchForm.dataset.mzSubmitBound = "1";
        researchForm.addEventListener("submit", function (event) {
            event.preventDefault();

            const pathParts = window.location.href.split("/");
            const parametersLast = pathParts[pathParts.length - 1];

            const body = {
                action: "mziq_save_webcast_access",
                name: popupName.value,
                email: popupEmail.value,
                company: popupCompany.value,
                phone: popupPhone.value,
                webcastName: popupWebcastName.value,
                webcastLink: researchForm.dataset.eventUrl || popupWebcastLink.value,
                webcastParameters: parametersLast,
                postId: researchForm.dataset.postId || "",
                type: researchForm.dataset.eventType || "",
            };

            saveNewWebcastLog(body);
        });
    }

    if (document.body.classList.contains("temporaryLoggedIn")) {
        const userInfoLocalStorage = JSON.parse(window.localStorage.getItem("userInfoCookies") || "null");
        if (!userInfoLocalStorage) {
            const toggle = document.getElementById("eventSignInToggle");
            if (toggle) toggle.click();
            return;
        }

        saveNewWebcastLog({
            action: "mziq_save_webcast_access",
            name: userInfoLocalStorage.name,
            email: userInfoLocalStorage.email,
            company: userInfoLocalStorage.company,
            phone: userInfoLocalStorage.phone,
            webcastName: popupWebcastName.value,
            webcastLink: researchForm.dataset.eventUrl || popupWebcastLink.value,
            postId: researchForm.dataset.postId || "",
            type: researchForm.dataset.eventType || "",
        });
    } else {
        const toggle = document.getElementById("eventSignInToggle");
        if (toggle) toggle.click();
    }
}

window.openResearchPopup = openResearchPopup;
